import { render, staticRenderFns } from "./BonusLeaderDuration.vue?vue&type=template&id=0674b5d1&scoped=true"
import script from "./BonusLeaderDuration.vue?vue&type=script&lang=js"
export * from "./BonusLeaderDuration.vue?vue&type=script&lang=js"
import style0 from "./BonusLeaderDuration.vue?vue&type=style&index=0&id=0674b5d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0674b5d1",
  null
  
)

export default component.exports